import React from 'react';

import Sidesheet from '~/components/Sidesheet';
import { Skeleton } from '~/components/utils';

import OverflowText from '../OverflowText';
import { Container, SidesheetCustomStyle } from './styles';

interface DetailsProps {
  loading: boolean;
  modalState: (opened: boolean) => void;
  open: boolean;
  title?: string;
}

const Details: React.FC<DetailsProps> = ({
  children,
  loading,
  modalState,
  open,
  title,
}) => {
  const renderTitle = () => {
    if (loading) return <Skeleton height={32} width={300} />;
    return title ? (
      <OverflowText title={title} lines={1}>
        {title}
      </OverflowText>
    ) : (
      'Sem Título'
    );
  };

  return (
    <Sidesheet
      title={renderTitle()}
      open={open}
      modalState={modalState}
      sidesheetSize="900px"
    >
      <SidesheetCustomStyle />
      <Container>{children}</Container>
    </Sidesheet>
  );
};

export default Details;
